import React, { ReactElement, useEffect } from 'react';
import { Loader } from 'idsk-react-components';
import { useParams } from 'react-router';
import {
  Breadcrumbs, getTitle, homeBreadcrumb, setTitle,
} from 'slovlex-idsk-react-components';
import routes from '../../../routing/routes';
import useLegislativnyMaterialDetail
  from '../../../module/LegislativnyMaterial/LegislativnyMaterialDetail/hooks/useLegislativnyMaterialDetail';
import PageHeadingWithBackButton from '../../../module/PageHeadingWithBackButton';
import VyjadreniaPredbeznaInformacia from '../../../module/PracovnyKrok/VyjadreniaPredbeznaInformacia';
import GlobalErrors from '../../../module/GlobalErrors';
import Layout from '../../Layout';
import SecuredPage from '../../../module/SecuredPage';
import PracovnyKrokEnum from '../../../model/pracovnyKrok/PracovnyKrokEnum';
import SuccessMessages from '../../../module/SuccessMessages';
import { UserRoleEnum } from '../../../model/currentuser/UserRole';
import pracovnyKrokAvailable from '../../../function/pracovnyKrokFunctions';
import { useSecurityContext } from '../../../context/SecurityContext';
import usePracovneKroky
  from '../../../module/LegislativnyMaterial/LegislativnyMaterialDetail/component/PracovneKroky/hooks/usePracovneKroky';

const VyjadreniaAdminStartPage = (): ReactElement => {
  const {
    type,
    year,
    index,
    pracovnyKrokId,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number, pracovnyKrokId: string }>();
  const {
    materialDetail,
    materialStatus,
  } = useLegislativnyMaterialDetail(PracovnyKrokEnum.PRECHOD_VYJADRENIA);

  const { accessToken } = useSecurityContext();
  const {
    pracovneKrokyRequest: pracovneKroky,
    pracovneKrokyStatus,
  } = usePracovneKroky(type, year, index, accessToken);

  useEffect(() => {
    if (!materialStatus.loading) {
      setTitle(getTitle());
    }
  }, [materialStatus.loading]);

  return (
    <Layout>
      <Breadcrumbs routeList={[
        homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        {
          to: routes.procesy.predbeznaInformacia.list,
          heading: 'Predbežné informácie',
        },
        {
          to: routes.procesy.detail.withParams(type, year, index),
          heading: `${type}/${year}/${index}`,
        },
        {
          to: routes.procesy.admin.vyjadrenia.start.withParams(type, year, index, pracovnyKrokId),
          heading: 'Konfigurácia doby pre vyjadrovanie k materiálu - admin',
        },
      ]}
      />
      <GlobalErrors />
      <Loader loading={materialStatus.loading || pracovneKrokyStatus.loading}>
        <SecuredPage
          additionalCheck={!!pracovnyKrokAvailable(pracovneKroky, PracovnyKrokEnum.PRECHOD_VYJADRENIA)}
          allowForRoles={[UserRoleEnum.SUPERADMIN]}
          requestStatus={materialStatus.responseCode}
        >
          <>
            <SuccessMessages />
            {materialDetail && (
              <>
                <PageHeadingWithBackButton
                  heading="Konfigurácia doby pre vyjadrovanie k materiálu - admin"
                  headingCaption={`Legislatívny proces ${materialDetail.cisloLegislativnehoMaterialu}`}
                />
                <VyjadreniaPredbeznaInformacia
                  materialDetail={materialDetail}
                  admin
                />
              </>
            )}
          </>
        </SecuredPage>
      </Loader>
    </Layout>
  );
};

export default VyjadreniaAdminStartPage;
